import http from "./http";

export function createViralTask(data) {
  return http({
    url: "/web/merchant/video-viral/task/create",
    method: "POST",
    data,
  });
}

export function getStatus(taskId) {
  return http({
    url: `/web/merchant/video-viral/task/${taskId}`,
    method: "GET",
  });
}

export function createGenerateTask(data) {
  return http({
    url: "/web/merchant/video-scripts/generate",
    method: "POST",
    data,
    timeout: 60 * 1000,
  });
}

export function getVideoScriptDetail(id) {
  return http({
    url: `/web/merchant/video-scripts/${id}`,
    method: "GET",
  });
}

export function createVideos(data) {
  return http({
    url: `/web/merchant/videos/generate`,
    method: "POST",
    data,
  });
}

export function recordList(data) {
  return http({
    url: `/web/merchant/video-content-record/page`,
    method: "POST",
    data,
  });
}

export function recordDetail(id) {
  return http({
    url: `/web/merchant/video-content-record/${id}`,
    method: "GET",
  });
}

export function delRecord(id) {
  return http({
    url: `/web/merchant/video-content-record/${id}`,
    method: "DELETE",
  });
}

export function publishList(data) {
  return http({
    url: `/web/merchant/api-video-publish/page`,
    method: "POST",
    data,
  });
}

export function createVideoPublish(data) {
  return http({
    url: `/web/merchant/api-video-publish/createVideoPublish`,
    method: "POST",
    data,
    imeout: 10 * 60 * 1000,
  });
}

export function getPoints() {
  return http({
    url: `/web/merchant/user/points`,
    method: "GET",
  });
}

export function getPointsPackages() {
  return http({
    url: `/web/merchant/user/points/packages`,
    method: "GET",
  });
}

export function getPointsPlans() {
  return http({
    url: `/web/merchant/user/points/plans`,
    method: "GET",
  });
}

export function getPointsConsumptionChart() {
  return http({
    url: `/web/merchant/user/points/consumption-chart`,
    method: "GET",
  });
}

export function getPointsRecords(data = {}) {
  return http({
    url: `/web/merchant/user/points/records`,
    method: "POST",
    data,
  });
}

export function getFlowSsoUrl(data) {
  // return http({
  //   url: `/web/merchant/flow/sso`,
  //   method: "POST",
  //   data,
  // });
  return {
    ...data,
    code: 200,
    data: {
      redirectUrl: "https://flow.9five.ai/app",
    },
  };
}

export function getTrialPointsConfig() {
  return http({
    url: `/web/merchant/trial-points/config`,
    method: "GET",
  });
}

export function claimTrialPoints(data) {
  return http({
    url: `/web/merchant/trial-points/claim`,
    method: "POST",
    data,
  });
}

export function getAiModels(params = {}) {
  return http({
    url: `/web/merchant/ai-models`,
    method: "GET",
    params,
  });
}

export function retryRecord(data) {
  return http({
    url: `/web/merchant/videos/retry`,
    method: "POST",
    data,
  });
}

export function deleteVideoPublish(data) {
  return http({
    url: `/web/merchant/api-video-publish/delete`,
    method: "POST",
    data,
  });
}

export function searchMusic(data) {
  return http({
    url: `/web/merchant/api-video-publish/searchMusic`,
    method: "POST",
    data,
  });
}

export function endTrialPoints() {
  return http({
    url: `/web/merchant/user/points/end-trial`,
    method: "POST",
  });
}

export function getTrialConvertStatus() {
  return http({
    url: `/web/merchant/user/points/trial-convert-status`,
    method: "GET",
  });
}
